import styled from 'styled-components';
import { breakpoint } from '../theme/breakpoint';
import { Container } from '../styled/containers';

export const HeaderWrapper = styled.header`
  width: 100%;
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.border}`};

  ${Container} {
    ${breakpoint.tablet`
      padding: ${({ theme }) => `0 ${theme.spacing.tiny}`};
    `}
    ${breakpoint.desktop`
      padding: ${({ theme }) => `0 ${theme.spacing.standard}`};
    `}
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  margin: ${({ theme }) => `0 ${theme.spacing.tiny}`};
  padding: ${({ theme }) => `${theme.spacing.tiny} 0`};

  ${breakpoint.tablet`
    margin: 0;
  `}

  ${breakpoint.desktop`
    padding: ${({ theme }) => `${theme.spacing.standard} 0`};
  `}
`;

export const HeaderRows = styled.div`
  flex: 1 0 auto;
`;

export const HeaderRowTop = styled.div`
  display: flex;
`;

export const HeaderRowBottom = styled.div`
  display: flex;
  align-items: center;

  ${breakpoint.desktop`
    margin-top: ${({ theme }) => theme.spacing.medium};
  `}
`;
